import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/industries.css';
import travelImg from '../../assets/travel.jpg';

const Travel = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${travelImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Travel</h1>
      <p>
        Building digital journeys — travel booking engines, itinerary automation, and immersive travel experiences.
      </p>
      <ul className="bullet-points">
        <li>✈️ Booking platforms & payment flows.</li>
        <li>🏨 Hotel and tour management.</li>
        <li>🧭 Smart itinerary builders.</li>
        <li>🗺️ Real-time maps & location features.</li>
      </ul>
    </motion.div>
  </div>
);

export default Travel;
